import { useContext } from "react";
import { Button } from "@shopify/polaris";
import styles from "./BBTemplate.module.css";
import { useFormContext } from "react-hook-form";
import { BundleBuilderConfigInterface } from "../../../Types";
import { AvailableBundleBuilderTemplates } from "../../../constants";
import { AppConfigContext } from "../../../../../context/AppConfigContext";
import CustomModal from "../../../../../components/CustomModal/CustomModal";
import { BundleBuilderPreview } from "../../BundleBuilderBundle/BundleBuilderBundle";

const BBTemplate = ({
    setOpenBBTemplateModal,
    bundleConfig,
    forAiBundle = false,
}: {
    openBBTemplateModal: any;
    setOpenBBTemplateModal: any;
    bundleConfig: any;
    standAlone: any;
    forAiBundle?: boolean;
}) => {
    const appConfigContext = useContext(AppConfigContext);
    const { setValue } = useFormContext<BundleBuilderConfigInterface>();

    const handleChangeSelectedTemplate = (template: any) => {
        setValue("selected_template_bb", template, { shouldDirty: true });

        setOpenBBTemplateModal(false);
    };

    return (
        <CustomModal
            open={true}
            title="Choose a Template"
            key={"template_sb"}
            onClose={() => setOpenBBTemplateModal(false)}
            primaryAction={{
                content: "Close",
                plain: true,
                onAction: () => setOpenBBTemplateModal(false),
            }}
            size={forAiBundle ? undefined : "large"}
        >
            <div
                className={styles.mainContainer}
                style={{
                    // @ts-expect-error required
                    "--columns": forAiBundle ? "1fr" : " 1fr 1fr",
                }}
            >
                <div className={styles.container}>
                    <BundleBuilderPreview
                        bundleConfig={{
                            ...bundleConfig,
                            selected_template_bb: AvailableBundleBuilderTemplates.FULL_CARD_INFO,
                            general_settings: {
                                show_powered_by_kefi: false,
                            },
                        }}
                        standAlone={false}
                        appConfigContext={appConfigContext}
                        previewType={1}
                        isTemplate={true}
                    />
                    <Button
                        variant={
                            bundleConfig.selected_template_bb == AvailableBundleBuilderTemplates.FULL_CARD_INFO
                                ? "primary"
                                : "secondary"
                        }
                        onClick={() => {
                            handleChangeSelectedTemplate(AvailableBundleBuilderTemplates.FULL_CARD_INFO);
                        }}
                    >
                        {bundleConfig.selected_template_bb == AvailableBundleBuilderTemplates.FULL_CARD_INFO
                            ? "Selected"
                            : "Select"}
                    </Button>
                </div>

                <div className={styles.container}>
                    <BundleBuilderPreview
                        bundleConfig={{
                            ...bundleConfig,
                            selected_template_bb: AvailableBundleBuilderTemplates.BASIC_CARD_INFO,
                            general_settings: {
                                show_powered_by_kefi: false,
                            },
                        }}
                        standAlone={false}
                        appConfigContext={appConfigContext}
                        previewType={1}
                        isTemplate={true}
                    />
                    <Button
                        variant={
                            bundleConfig.selected_template_bb == AvailableBundleBuilderTemplates.BASIC_CARD_INFO
                                ? "primary"
                                : "secondary"
                        }
                        onClick={() => {
                            handleChangeSelectedTemplate(AvailableBundleBuilderTemplates.BASIC_CARD_INFO);
                        }}
                    >
                        {bundleConfig.selected_template_bb == AvailableBundleBuilderTemplates.BASIC_CARD_INFO
                            ? "Selected"
                            : "Select"}
                    </Button>
                </div>

                <div className={styles.container}>
                    <BundleBuilderPreview
                        bundleConfig={{
                            ...bundleConfig,
                            selected_template_bb: AvailableBundleBuilderTemplates.IMG_FOCUS_CARD,
                            general_settings: {
                                show_powered_by_kefi: false,
                            },
                        }}
                        standAlone={false}
                        appConfigContext={appConfigContext}
                        previewType={1}
                        isTemplate={true}
                    />
                    <Button
                        variant={
                            bundleConfig.selected_template_bb == AvailableBundleBuilderTemplates.IMG_FOCUS_CARD
                                ? "primary"
                                : "secondary"
                        }
                        onClick={() => {
                            handleChangeSelectedTemplate(AvailableBundleBuilderTemplates.IMG_FOCUS_CARD);
                        }}
                    >
                        {bundleConfig.selected_template_bb == AvailableBundleBuilderTemplates.IMG_FOCUS_CARD
                            ? "Selected"
                            : "Select"}
                    </Button>
                </div>

                <div className={styles.container}>
                    <BundleBuilderPreview
                        bundleConfig={{
                            ...bundleConfig,
                            selected_template_bb: AvailableBundleBuilderTemplates.HOVER_ACTION_CARD,
                            general_settings: {
                                show_powered_by_kefi: false,
                            },
                        }}
                        standAlone={false}
                        appConfigContext={appConfigContext}
                        previewType={1}
                        isTemplate={true}
                    />
                    <Button
                        variant={
                            bundleConfig.selected_template_bb == AvailableBundleBuilderTemplates.HOVER_ACTION_CARD
                                ? "primary"
                                : "secondary"
                        }
                        onClick={() => {
                            handleChangeSelectedTemplate(AvailableBundleBuilderTemplates.HOVER_ACTION_CARD);
                        }}
                    >
                        {bundleConfig.selected_template_bb == AvailableBundleBuilderTemplates.HOVER_ACTION_CARD
                            ? "Selected"
                            : "Select"}
                    </Button>
                </div>

                <div className={styles.container}>
                    <BundleBuilderPreview
                        bundleConfig={{
                            ...bundleConfig,
                            selected_template_bb: AvailableBundleBuilderTemplates.HOVER_INFO_CARD,
                            general_settings: {
                                show_powered_by_kefi: false,
                            },
                        }}
                        standAlone={false}
                        appConfigContext={appConfigContext}
                        previewType={1}
                        isTemplate={true}
                    />
                    <Button
                        variant={
                            bundleConfig.selected_template_bb == AvailableBundleBuilderTemplates.HOVER_INFO_CARD
                                ? "primary"
                                : "secondary"
                        }
                        onClick={() => {
                            handleChangeSelectedTemplate(AvailableBundleBuilderTemplates.HOVER_INFO_CARD);
                        }}
                    >
                        {bundleConfig.selected_template_bb == AvailableBundleBuilderTemplates.HOVER_INFO_CARD
                            ? "Selected"
                            : "Select"}
                    </Button>
                </div>
            </div>
        </CustomModal>
    );
};

export default BBTemplate;
